import { ValidationFailure } from "./ValidationFailure";

export interface ValidationResult {
  isValid: boolean;
  failures: ValidationFailure[];
  addFailure?(errorMessage: string): void;
}

export function addFailure(result: ValidationResult, errorMessage: string) {
  result.failures.push({ errorMessage });
  result.isValid = false;
}
